export default "__VITE_ASSET__Dewr0a4E__"